import { render, staticRenderFns } from "./BrandPartsAttributeEditLayer.vue?vue&type=template&id=6f72c9d9&scoped=true&"
import script from "./BrandPartsAttributeEditLayer.vue?vue&type=script&lang=js&"
export * from "./BrandPartsAttributeEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsAttributeEditLayer.vue?vue&type=style&index=0&id=6f72c9d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72c9d9",
  null
  
)

export default component.exports